import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const POST_APP_LOGIN_PROCESSOR: InjectionToken<PostAppLoginProcessor> = new InjectionToken('POST_APP_LOGIN_PROCESSOR');

/**
 * Event that will be triggered AFTER connected app successfull login
 * Events will be executed in registration order
 */
export interface PostAppLoginProcessor {
	execute(): Observable<any>;
}
